

import meBoy from "../data/imgs/icons/app/meBoy.png";
import me from "../data/imgs/icons/app/meDefault.png";
import React, { useState, useRef, useEffect } from "react";
import { useMp3Player } from "../providers/mp3PlayerContext";

export default () => {

  const [meImg] = useState(me);
  const [meBoyImg] = useState(meBoy);
  const wrapperProfileRef = useRef(null);
  const { toastDisplay, setToastDisplay } = useMp3Player();
  const [isProfileActive, setProfileActive] = useState(false);

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (wrapperProfileRef.current && !wrapperProfileRef.current.contains(event.target)) {
        setProfileActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => { document.removeEventListener("mousedown", handleClickOutside) };
  }, []);

  const handleToggle = () => {
    
    setProfileActive((prev) => !prev);
    if (toastDisplay) {
      setToastDisplay(false);
    }
  };

  return (
    <div className="profile dropdown" ref={wrapperProfileRef}>
      {meImg &&
        <img className="profile-pic dropbtn"
          src={meImg} alt="profile"
          onClick={handleToggle}
          style={{
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
          }} />}
      <div className={isProfileActive ? "profile-details-dropdown dropdown-show" : "profile-details-dropdown dropdown-hide"}>
        <div className="first-detail">
          {meBoyImg &&
            <img src={meBoyImg} alt="profile" 
              style={{
                boxShadow: "0 8px 24px rgba(66, 133, 244, 0.2)",
                border: "3px solid rgba(66, 133, 244, 0.2)",
                transition: "all 0.3s ease"
              }} />}
          <p className="detail-text" style={{ fontWeight: "700", fontSize: "18px", color: "#202124" }}>
            Avri Yom Tov
          </p>
          <br />
          <p className="detail-text" style={{ 
            fontWeight: "600", 
            fontSize: "14px",
            background: "linear-gradient(135deg, #4285f4 0%, #34a853 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text"
          }}>
            SOFTWARE ENGINEER
          </p>
        </div>
        <p className="detail-text" style={{ fontWeight: "bold" }}>
          Yoti1492@gmail.com
        </p>
        <p className="detail-text" style={{ fontWeight: "bold" }}>
          0533300845
        </p>
        <div style={{ borderBottom: "1px solid #eee" }}></div>
        <div className="first-detail">
          <a style={{ fontWeight: "bold" }} href="https://github.com/Avri-Here" target="_blank" rel="noreferrer">
            Github
          </a>

          <span style={{ fontWeight: "bold", margin: "0 8px" }}></span>
          <a style={{ fontWeight: "bold" }} href="https://www.linkedin.com/in/avraham-yom-tov-a74525231/" target={"_blank"} rel="noreferrer">
            Linkedin
          </a>
        </div>
      </div>
    </div>
  );
};
